import { Component, OnInit } from '@angular/core';
import { MenuLink } from '@app/shared/api/menu.api';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { GuiParams } from '@app/shared/store/gui-params/gui-params-facade.service';

@Component({
  selector: 'app-profile-navigation',
  templateUrl: './profile-navigation.component.html',
  styleUrls: ['./profile-navigation.component.scss'],
})
export class ProfileNavigationComponent implements OnInit {
  appState$ = this.guiParams.appState$;
  appState = 'operational';
  userDetail: MenuLink[] = [
    {
      text: 'shared.menu.profile',
      link: '/account-profile',
    },
    {
      text: 'shared.menu.security',
      link: '/security',
    },
    {
      text: 'shared.menu.verification',
      link: '/verification',
    },
    {
      text: 'shared.menu.price-alerts',
      link: '/price-alerts',
    },
    {
      text: 'API',
      link: '/account-api',
    },
    {
      text: 'shared.menu.user-log',
      link: '/user-log',
    },
    {
      text: 'shared.menu.referral',
      link: '/referral',
    },
  ];
  private unsubscribe$: Subject<any> = new Subject<any>();

  constructor(public router: Router, private guiParams: GuiParams) {}

  ngOnInit(): void {
    this.appState$.pipe(takeUntil(this.unsubscribe$)).subscribe((appState) => {
      this.appState = appState;
    });
  }

  protected readonly String = String;
}
